import { render, staticRenderFns } from "./FaleConosco.vue?vue&type=template&id=3394342c&"
import script from "./FaleConosco.vue?vue&type=script&lang=js&"
export * from "./FaleConosco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports